export interface ISpeciality {
  specialityId: string;
  nameEnglish: string;
  nameArabic: string;
  code: number;
}

export const specialtyConfig = {
  entityName: 'Speciality',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  CODE: 'FORM_FIELD.CODE'
};

